import { createFileRoute, redirect } from '@tanstack/react-router';

import type { RouterContext } from '@shared/config/router-context';
import { getDefaultAnalyticsPath } from '@shared/lib';

/**
 * Analytics Index Route
 *
 * Route: /:locale/analytics/
 */
export const Route = createFileRoute('/$locale/_authenticated/analytics/')({
  beforeLoad: ({ context, params }) => {
    const { ability } = context as RouterContext;
    const nextPath = getDefaultAnalyticsPath(ability);

    if (!nextPath) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: '/$locale/unauthorized',
        params: { locale: params.locale },
      });
    }

    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: nextPath,
      params: { locale: params.locale },
    });
  },
});
